import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchUserOwnTractorViewsById } from '../../../../api/product/mutations/patchUserOwnTractorViewsById';
import { usersOwnTractorsApiUrl } from '../../../../api/product/queries/getUsersOwnTractors';
import { IUserOwnTractorDetail } from '../../../../interfaces/OwnTractor.interfaces';

export const usePatchUserOwnTractorViewsById = () => {
  const queryClient = useQueryClient();
  return useMutation(patchUserOwnTractorViewsById, {
    onMutate: async ({ productId }) => {
      await queryClient.cancelQueries([usersOwnTractorsApiUrl, productId]);
      const previousData = queryClient.getQueryData([usersOwnTractorsApiUrl, productId]);

      queryClient.setQueryData([usersOwnTractorsApiUrl, productId], (oldData: IUserOwnTractorDetail | undefined) => {
        if (!oldData) {
          return oldData;
        }
        return {
          ...oldData,
          views: oldData.views + 1,
        };
      });

      return { previousData };
    },
    onError: (err, { productId }, context) => {
      queryClient.setQueryData([usersOwnTractorsApiUrl, productId], context?.previousData);
    },
    onSettled: (data, error, { productId }) => {
      queryClient.invalidateQueries([usersOwnTractorsApiUrl, productId]);
    },
  });
};
